// Copyright (c) Microsoft. All rights reserved.

import { Image, makeStyles } from '@fluentui/react-components';
import React from 'react';
import { useAppSelector } from '../../../redux/app/hooks';
import { RootState } from '../../../redux/app/store';
import { FeatureKeys } from '../../../redux/features/app/AppState';
import typingBalls from '../../../assets/typing-balls-light.svg';

const useStyles = makeStyles({
    root: {
        contain: 'strict',
        height: '28px',
        overflowY: 'hidden',
        width: '28px',
    },
    image: {
        animationDuration: '2.3s',
        animationIterationCount: 'infinite',
        animationName: {
            from: { transform: 'translateY(0)' },
            // 28px Height * 68 Steps = 1904px
            to: { transform: 'translateY(-1904px)' },
        },
        animationTimingFunction: 'steps(68)',
    },
    imageDark: {
        filter: 'brightness(0) invert(1)',
    },
});

export const TypingIndicator: React.FC = () => {
    const classes = useStyles();
    const { features } = useAppSelector((state: RootState) => state.app);
    const isDarkMode = features[FeatureKeys.DarkMode].enabled;

    return (
        <div className={classes.root}>
            <Image
                role="presentation"
                className={isDarkMode ? `${classes.image} ${classes.imageDark}` : classes.image}
                src={typingBalls}
            />
        </div>
    );
};
